export default {"src":"/_next/static/media/truck-icon.16e16b40.svg","height":19,"width":26,"blurWidth":0,"blurHeight":0};